const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000/api";

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

/* ---------------------------------------------------
   LISTAR SECCIONES
---------------------------------------------------- */

export async function getSecciones() {
  try {
    const res = await fetch(`${API_BASE}/catalogos/secciones-academicas/`, {
      headers: getAuthHeaders()
    });

    if (!res.ok) {
      console.error("Error al obtener secciones:", res.status);
      return [];
    }

    const data = await res.json();

    return Array.isArray(data)
      ? data.map((s) => ({
          id: s.id_seccion ?? s.id ?? null,
          institucion: s.id_institucion ?? null,
          nombre: s.nombre_seccion ?? "",
          codigo: s.codigo_seccion ?? "",
          descripcion: s.descripcion ?? "",
          estado: s.activo ? "ACTIVO" : "INACTIVO",
          orden: s.orden ?? 0,
        }))
      : [];
  } catch (e) {
    console.error("ERROR getSecciones:", e);
    return [];
  }
}

/* ---------------------------------------------------
   CREAR SECCIÓN
---------------------------------------------------- */
export async function createSeccion(form) {
  const payload = {
    id_institucion: Number(form.institucion),
    nombre_seccion: form.nombre,
    codigo_seccion: form.codigo,
    descripcion: form.descripcion,
    activo: form.estado === "ACTIVO",
    orden: Number(form.orden) || 0,
  };

  const res = await fetch(`${API_BASE}/catalogos/secciones-academicas/`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    console.error(await res.text());
    throw new Error("Error al crear sección académica");
  }

  return await res.json();
}

/* ---------------------------------------------------
   ACTUALIZAR SECCIÓN
---------------------------------------------------- */
export async function updateSeccion(id, form) {
  const payload = {
    id_institucion: Number(form.institucion),
    nombre_seccion: form.nombre,
    codigo_seccion: form.codigo,
    descripcion: form.descripcion,
    activo: form.estado === "ACTIVO",
    orden: Number(form.orden) || 0,
  };

  const res = await fetch(`${API_BASE}/catalogos/secciones-academicas/${id}/`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    console.error(await res.text());
    throw new Error("Error al actualizar sección académica");
  }

  return await res.json();
}

/* ---------------------------------------------------
   ELIMINAR SECCIÓN
---------------------------------------------------- */
export async function deleteSeccion(id) {
  const res = await fetch(`${API_BASE}/catalogos/secciones-academicas/${id}/`, {
    method: "DELETE",
    headers: getAuthHeaders()
  });

  if (!res.ok) {
    console.error(await res.text());
    throw new Error("Error al eliminar sección académica");
  }

  return true;
}
